module.exports = __webpack_public_path__ + "img/sink-kitchen-pc.7eca9f2f.png";